import { normalizeValue } from '@dte/otw-utils-core/src/strings/normalizeValue';

export function addSearchParam(
	searchParams: URLSearchParams,
	key: string,
	value: string | undefined | null,
): URLSearchParams {
	const newSearchParams = new URLSearchParams(searchParams);

	// TODO: should we be using lowercase everywhere for keys?
	const normalizedKey = normalizeValue(key);
	if (!normalizedKey) {
		return newSearchParams;
	}

	const normalizedValue = normalizeValue(value);
	if (normalizedValue) {
		newSearchParams.set(normalizedKey, normalizedValue);
	} else {
		newSearchParams.delete(normalizedKey);
	}

	return newSearchParams;
}

const dummyDomain = 'http://example.com';

export function addSearchParamsToUrl(
	originalUrl: string,
	params: Record<string, string | undefined | null> | undefined | null = {},
): string {
	// No URL to modify
	const normalized = normalizeValue(originalUrl);
	if (!normalized) {
		throw new Error('Invalid URL');
	}

	// Nothing to add
	if (!params) {
		return originalUrl;
	}

	// TODO: need to better handle this

	// Treat as a relative url if it doesn't have a scheme
	const relativeUrl = !normalized.startsWith('http');

	let url: URL;
	try {
		if (relativeUrl) {
			// Handle relative URLs by providing a base URL
			url = new URL(normalized, dummyDomain);
		} else {
			url = new URL(normalized);
		}
	} catch (error) {
		throw new Error('Invalid URL', { cause: error });
	}

	// Include existing parameters
	let searchParams = new URLSearchParams(url.search);

	// Append new parameters to existing ones
	for (const [key, value] of Object.entries(params)) {
		searchParams = addSearchParam(searchParams, key, value);
	}

	// Set the updated search parameters back to the URL object
	url.search = searchParams.toString();

	// Return the pathname and search part of the URL to handle relative URLs correctly

	let updatedUrl = url.toString();
	if (relativeUrl) {
		updatedUrl = updatedUrl.substring(dummyDomain.length);
	}

	return updatedUrl;
}

export function addSearchParamToUrl(originalUrl: string, key: string, value: string | undefined | null): string {
	return addSearchParamsToUrl(originalUrl, { [key]: value });
}
